import { render, staticRenderFns } from "./AlertUnsupportedBrowser.vue?vue&type=template&id=0bfe8c6d&"
import script from "./AlertUnsupportedBrowser.vue?vue&type=script&lang=js&"
export * from "./AlertUnsupportedBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports